import React, { Component } from 'react';
import {Link} from 'react-router-dom';

const allTackTitle= [
    //1
    {
        title: '任务ID',
        dataIndex: 'task_id',
        key: 'task_id',
        width:80,
    },
    //2
    {
        title: '任务名',
        dataIndex: 'name',
        key: 'name',
        width:240,
        render: (text,record) => {
            return <Link target={'_blank'} to={`/questionmanage/questionexplain/explaindetail/${record.task_id}`}>{text}</Link>;
        }
    },
    //3
    {
        title: '创建时间',
        dataIndex: 'create_time',
        key: 'create_time',
        width:120,
    },
    //4
    {
        title: '返工时间',
        dataIndex: 'rework_time',
        key: 'rework_time',
        width:120,
    },
    //5
    {
        title: '总题数/编写解析',
        dataIndex: 'statics',
        key: 'statics',
        width:160,
    },
    //6
    {
        title: '总题数/编写解析/审核完成',
        dataIndex: 'statics_check',
        key: 'statics_check',
        width:200,
    },
    //7
    {
        title: '总题数/录解析',
        dataIndex: 'statics_text',
        key: 'statics_text',
        width:160,
    },
    //8
    {
        title: '总题数/录解析/审核完成',
        dataIndex: 'statics_text_check',
        key: 'statics_text_check',
        width:200,
    },
    //9
    {
        title: <span>编写通过/<span style={{color:'red'}}>打回</span></span>,
        dataIndex: 'passNum',
        key: 'passNum',
        width:240,
        render: (text, record) => (
            <span>{record.question_count_pic_pass}<span style={{color:'red'}}>/{record.question_count_pic_rework}</span></span>
        )
    },
    //0
    {
        // title: '文字通过/打回',
        title:<span>录通过/<span style={{color:'red'}}>打回</span></span>,
        dataIndex: 'passNum_text',
        key: 'passNum_text',
        width:240,
        render: (text, record) => (
            <span>{record.question_count_text_pass}<span style={{color:'red'}}>/{record.question_count_text_rework}</span></span>
        )
    },
    //1
    {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width:80,
    },
    //2
    {
        title: '编写解析员',
        dataIndex: 'imgExplain',
        key: 'imgExplain',
        width:120,
    },
    //3
    {
        title: '编写解析组长',
        dataIndex: 'imgExplain_group',
        key: 'imgExplain_group',
        width:120,
    },
    //4
    {
        title: '编写解析审核员',
        dataIndex: 'imgExplainCheck',
        key: 'imgExplainCheck',
        width:160,
    },
    //5
    {
        title: '录解析员',
        dataIndex: 'textExplain',
        key: 'textExplain',
        width:120,
    },
    //6
    {
        title: '录解析组长',
        dataIndex: 'textExplain_group',
        key: 'textExplain_group',
        width:120,
    },
    //7
    {
        title: '录解析审核员',
        dataIndex: 'textExplainCheck',
        key: 'textExplainCheck',
        width:160,
    },
]



const getFilterColumns=(role_qbox,type)=>{
    if(!role_qbox){
        return [];
    }
    // role_qbox.columns = [
    // //   0,1,2,3,4,5,6,7,8,9,0,1,2,3,4,5,6
    //     [1,1,1,0,1,0,0,0,0,0,1,1,1,1,0,0,0],//待分配
    //     [1,1,1,0,1,0,0,0,0,0,0,1,1,0,0,0,0],//编写解析
    //     [1,1,1,0,0,1,0,0,1,0,1,1,1,1,0,0,0],//待编写解析审核
    //
    //     [1,1,0,0,1,0,0,0,1,0,1,1,1,1,0,0,0],//编写解析审核
    //     [1,1,1,1,1,0,0,0,1,0,1,0,0,1,0,0,0],//编写解析返工
    //     [1,1,1,0,1,0,0,0,0,0,1,0,0,1,0,0,0],//待录解析
    //     [1,1,1,0,0,0,1,0,0,1,0,0,0,0,1,1,1],//录解析
    //     [1,1,1,0,0,0,0,1,0,1,1,0,0,0,1,1,1],//录解析审核
    //     [1,1,1,0,0,0,0,1,0,1,1,0,0,0,1,1,1],//待录解析审核
    //
    //
    //
    //     [1,1,1,1,0,0,0,1,0,1,1,0,0,0,0,0,1],//录解析返工
    //
    //     [1,1,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1],//审核完成
    //
    //     [1,1,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1],//上线中
    //
    //     [1,1,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1],//上线成功
    //
    //     [1,1,1,0,0,0,0,1,0,0,1,0,0,1,0,0,1],//上线失败
    // ]

    let r = []
    switch (type){
        case 'pre_assign':
            r = role_qbox.columns[0]
            break;
        case 'img_explain':
            r = role_qbox.columns[1]
            break;
        case 'pre_img_explain_check':
            r = role_qbox.columns[2]
            break;

        case 'img_explain_check':
            r = role_qbox.columns[3]
            break;
        case 'img_explain_rework':
            r = role_qbox.columns[4]
            break;
        case 'pre_text_explain':
            r = role_qbox.columns[5]
            break;
        case 'text_explain':
            r = role_qbox.columns[6]
            break;
        case 'pre_text_explain_check':
            r = role_qbox.columns[7]
            break;
        case 'text_explain_check':
            r = role_qbox.columns[8]

            break;
        case 'text_explain_rework':
            r = role_qbox.columns[9]

            break;
        case 'text_explain_pass':
            r = role_qbox.columns[10]

            break;
        case 'text_explain_onlineing':
            r = role_qbox.columns[11]

            break;
        case 'text_explain_online_success':
            r = role_qbox.columns[12]

            break;
        case 'text_explain_online_fail':
            r = role_qbox.columns[13]

            break;

        default:
            break;
    }
    //判断按钮是否显示
    let arr=[]
    allTackTitle.forEach((d,i)=>{
        if(r[i]){
            arr.push(d)
        }
    })
    return arr
}
export {getFilterColumns}


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/explain_task_list/columns.js